// @ts-check
import React from 'react';
import { Modal, ModalHeader } from 'preferral-ui/components/Modal';
import { NewDataExportForm } from './NewDataExportForm';
import { FilterModel } from '../FilterPanel'; // eslint-disable-line no-unused-vars

/** @typedef {{
  isOpen: boolean;
  onClose(): void;
  filter: FilterModel;
}} DataExportModalProps */

/** @type { React.FC<DataExportModalProps> } */
export const DataExportModal = (props) => {
  const { isOpen, onClose, filter } = props;
  return (
    <Modal
      className="_DataExportModal"
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <ModalHeader icon="file-download" title="Export Data" onClose={onClose} />

      <div className="p-4">
        <NewDataExportForm filter={filter} onSuccess={onClose} />
      </div>
    </Modal>
  );
};
